import ItinerariesManager from "@/shared/ItinerariesManager";

export default function AdminItineraries() {
  return (
    <div className="px-8 py-10 lg:px-12 lg:py-14" data-testid="admin-itineraries-page">
      <div className="overline">Auto-educação</div>
      <h1 className="display-heading text-4xl sm:text-5xl mt-3">Percursos de auto-educação.</h1>
      <span className="accent-rule mt-6 block" />
      <p className="mt-4 max-w-2xl text-sm text-[hsl(var(--muted-foreground))]">
        Crie modelos de itinerário (8 sessões customizáveis), lance edições com datas reais e
        gira os participantes. Os emails — documento de estudo, lembrete na véspera e 2 horas
        antes — são enviados automaticamente.
      </p>
      <div className="mt-8">
        <ItinerariesManager />
      </div>
    </div>
  );
}
